import { Component, Input, OnChanges, OnInit } from '@angular/core'
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms'
import { StoreService } from '../../services/store.service'
import { city } from '../../models/store.model'
import { BranchInformationModel } from 'src/app/modules/organization/models/branch-information.model'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-store-profile-delivery-info',
	templateUrl: './store-profile-delivery-info.component.html',
	styleUrls: ['./store-profile-delivery-info.component.scss'],
})
export class StoreProfileDeliveryInfoComponent implements OnInit, OnChanges {
	@Input() branchInformationData = new BranchInformationModel()
	editMode: boolean = false
	panelOpenState = false
	maxLength!: number
	deliveryInfo!: FormGroup
	shippingCompanies!: FormGroup
	data: any = [
		{ cityId: 1, fees: 30, cityName: 'alexandria' },
		{ cityId: 2, fees: 40, cityName: 'cairo' },
		{ cityId: 3, fees: 50, cityName: 'aswan' },
	]

	shippingcompaniestest: any = [
		{
			companyName: 'adwat',
			companyNumber: '+966 56 756 9383',
			contactName: 'owner',
		},
		{
			companyName: 'adwat2',
			companyNumber: '+966 56 756 9383',
			contactName: 'owner2',
		},
		{
			companyName: 'adwat3',
			companyNumber: '+966 56 756 9383',
			contactName: 'owner3',
		},
	]
	selectedCountries: any[] = []
	shippingFeesTabExpanded: boolean = false
	shippingCompaniesTabExpanded: boolean = false

	allcities: city[] = []
	constructor(
		private formBuilder: FormBuilder,
		private StoreService: StoreService,
		public translate: TranslateService
	) {}

	ngOnInit(): void {
		this.initForm()
		// this.pushData()
		this.deliveryInfo.valueChanges.subscribe((res) => {
			this.selectedCountries = this.getDeliveryInputs()
				.getRawValue()
				.map((item: { cityId: any }) => item.cityId)
		})
	}
	ngOnChanges(): void {
		this.branchInformationData ? this.getCities() : null
		this.maxLength = this.branchInformationData?.country?.id == 224 ? 11 : 12
	}
	initForm() {
		this.deliveryInfo = this.formBuilder.group({
			cities: this.formBuilder.array([], Validators.required),
		})
		this.shippingCompanies = this.formBuilder.group({
			companies: this.formBuilder.array([]),
		})
	}
	pushData() {
		this.data.forEach(
			(delivery: { cityId: any; fees: any; cityName: string }) => {
				this.addInput(delivery.cityId, delivery.fees, delivery.cityName)
			}
		)
	}
	getCities() {
		this.StoreService.getCities(
			this.branchInformationData?.country?.id
		).subscribe((res: any) => (this.allcities = res.result))
	}
	getDeliveryInputs() {
		return this.deliveryInfo.controls['cities'] as any
	}
	getDeliveryCompaniesInputs() {
		return this.shippingCompanies.controls['companies'] as any
	}
	getFormArray() {
		return this.deliveryInfo.get('cities') as FormArray
	}

	getCompanyFormArray() {
		return this.shippingCompanies.get('companies') as FormArray
	}

	getController(index: number, controllerName: string) {
		return (this.getFormArray()?.controls[index] as FormGroup)?.get(
			controllerName
		)
	}

	getCompanyController(index: number, controllerName: string) {
		return (this.getCompanyFormArray()?.controls[index] as FormGroup)?.get(
			controllerName
		)
	}

	addInput(cityId?: any, fees?: any, cityName?: string) {
		const selectedCityForm: FormGroup = this.formBuilder.group({
			cityName: [''],
			isActive: [false],
			cityId: ['' || cityId, Validators.required],
			fees: [0 || fees, Validators.required],
		})
		this.getDeliveryInputs().push(selectedCityForm)
		this.shippingFeesTabExpanded = true
	}

	addCompanyInput(cityId?: any, fees?: any) {
		const companyDetails: FormGroup = this.formBuilder.group({
			companyName: ['', Validators.required],
			companyNumber: [0, Validators.required],
			contactName: ['', Validators.required],
		})
		this.getDeliveryCompaniesInputs().push(companyDetails)
		this.shippingCompaniesTabExpanded = true
	}
	removeDelivery(index: number) {
		this.getDeliveryInputs().removeAt(index)

		if (index > -1) {
			this.selectedCountries.splice(index, 1)
		}
	}

	removeShippingCompany(index: number) {
		this.getDeliveryCompaniesInputs().removeAt(index)

		if (index > -1) {
			this.selectedCountries.splice(index, 1)
		}
	}

	cancel() {
		this.getDeliveryInputs().controls = []
		this.getDeliveryCompaniesInputs().controls = []
	}

	isNumber(evt: any) {
		evt = evt ? evt : window.event
		var charCode = evt.which ? evt.which : evt.keyCode
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false
		}
		return true
	}

	maxMobileLength(index: number) {
		this.maxLength = this.branchInformationData?.country?.id == 224 ? 11 : 12

		if (this.getCompanyController(index, 'companyNumber')?.value.length) {
			if (
				this.getCompanyController(index, 'companyNumber')?.value.length >=
				this.maxLength
			) {
				console.log(
					this.getCompanyController(index, 'companyNumber')?.value.length,
					'current length'
				)
				console.log(this.maxLength, 'maxlength')

				this.getCompanyController(index, 'companyNumber')?.setValue(
					this.getCompanyController(index, 'companyNumber')?.value.slice(
						0,
						this.maxLength
					)
				)
				console.log(
					this.getCompanyController(index, 'companyNumber')?.value,
					'current value'
				)
			}
		}
	}

	selectionChange(city: any, i: number) {
		this.selectedCountries = this.getDeliveryInputs()
			.getRawValue()
			.map((item: { cityId: any }) => item.cityId)

		this.selectedCountries[i] = city
	}
	submit(data?: any) {
		let branchId: number = this.branchInformationData.id
		let body = {
			...this.getDeliveryInputs().getRawValue(),
			branchId,
		}
	}
}
